<template>
  <div>
    <div class="relative min-h-screen lg:flex" data-dev-hint="container">
      <input type="checkbox" id="menu-open" class="hidden" />

      <label
        for="menu-open"
        class="absolute right-2 bottom-2 shadow-lg rounded-full p-2 bg-gray-100 text-gray-600 lg:hidden"
        data-dev-hint="floating action button"
      >
        <svg
          class="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </label>

      <Header />

      <Sidebar
        :currentRoute="currentRoute"
        :isModalOpen="isModalOpen"
        :toggleModalOpen="toggleModalOpen"
      />

      <ContentWrapper />
    </div>

    <LogoutModal
      :isModalOpen="isModalOpen"
      :toggleModalOpen="toggleModalOpen"
      :logout="logout"
    />
  </div>
</template>

<script>
import { computed, onMounted, ref, watchEffect } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useIdle, useTimestamp } from "@vueuse/core";
import Sidebar from "@/components/sidebar.vue";
import Header from "@/components/Header.vue";
import ContentWrapper from "@/components/ContentWrapper.vue";
import LogoutModal from "@/components/modals/LogoutModal.vue";

export default {
  components: {
    LogoutModal,
    Sidebar,
    Header,
    ContentWrapper,
  },
  setup() {
    const isOpen = ref(false);
    const store = useStore();
    const currentRoute = computed(() => {
      return useRoute().name;
    });

    const { idle, lastActive } = useIdle(1000000);

    const now = useTimestamp();

    const idledFor = computed(() =>
      Math.floor((now.value - lastActive.value) / 1000)
    );

    watchEffect(() => {
      if (idle.value === true) {
        logout();
      }
    });

    const isModalOpen = computed(() => isOpen.value);

    const toggleModalOpen = () => {
      isOpen.value = !isOpen.value;
    };

    const logout = () => {
      localStorage.clear();

      window.location.href = "/";
    };

    const dispatchActions = () => {
      store.dispatch("getLatestFundedAndUnfunded");
      store.dispatch("getTickets");
      store.dispatch("getLatestRemittance"),
        store.dispatch("getAllRemittanceData");
        store.dispatch("getAllEmployees");
    };

    onMounted(() => {
      dispatchActions();
    });

    return {
      currentRoute,
      logout,
      isModalOpen,
      toggleModalOpen,
      idledFor,
      idle,
      lastActive,
      dispatchActions,
    };
  },
};
</script>

<style scoped>
#menu-open:checked ~ #sidebar {
  --tw-translate-x: 0;
}

#menu-open:checked ~ * #menu-open-icon {
  display: none;
}

#menu-open:checked ~ * #menu-close-icon {
  display: block;
}
</style>
